module.exports = __webpack_public_path__ + "img/common_descriptionlevel_ssr.04462469.svg";